<div class="date-picker">
  <input
    class="form-control lna"
    #d="ngbDatepicker"
    [(ngModel)]="dateObject"
    [ngClass]="{ invalid: invalid }"
    [minDate]="minDateToUse"
    [maxDate]="maxDateToUse"
    [disabled]="disabled"
    (ngModelChange)="onModelChange($event)"
    (click)="d.toggle()"
    (blur)="onBlur()"
    placeholder="dd.mm.gggg"
    name="dp"
    ngbDatepicker />
</div>
